export default __webpack_public_path__ + "static/media/Excel_icon.3d15829e.svg";